import {assertAndContinue} from 'Asserts';
import {typeToName} from 'util/NameUtil';

import {
  LeafType,
  isLeafTypePrimitive,
  PrimitiveLeafType,
  BenchlingTypeDef,
  isBenchlingTypeDefComplex,
  isBenchlingTypeDefAny,
} from './BenchlingTypeDef';
import {TYPE_DEF_TO_MODEL_TYPE} from './ModelToTypeDef';

export const PRIMITIVE_TYPE_DEF_TO_NAME: {[leafType in PrimitiveLeafType]: string} = {
  [LeafType.BOOLEAN]: 'boolean',
  [LeafType.DATE]: 'date',
  [LeafType.DATETIME]: 'datetime',
  [LeafType.DECIMAL]: 'decimal',
  [LeafType.INTEGER]: 'integer',
  [LeafType.JSON]: 'JSON',
  [LeafType.TEXT]: 'text',
};

export function readableTypeDef(typeDef: BenchlingTypeDef): string {
  if (isBenchlingTypeDefComplex(typeDef)) {
    const innerReadableTypeDefs = typeDef
      .getBaseTypes()
      .map((t) => readableTypeDef(t))
      .join(', ');
    return `${typeDef.getOperatorName()}[${innerReadableTypeDefs}]`;
  } else if (isBenchlingTypeDefAny(typeDef)) {
    return 'any';
  } else if (isLeafTypePrimitive(typeDef)) {
    return PRIMITIVE_TYPE_DEF_TO_NAME[typeDef];
  } else if (typeDef === LeafType.BENCHLING_OBJECT) {
    return 'object';
  }

  if (TYPE_DEF_TO_MODEL_TYPE[typeDef] == null) {
    assertAndContinue(false, 'Type def not included in model type mapping', {typeDef});
    return 'any';
  }

  return typeToName(TYPE_DEF_TO_MODEL_TYPE[typeDef]);
}
